import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MDialogComponent } from 'src/app/components/m-dialog/m-dialog.component';
import { DescriptionTypes, Finalidades, FinalidadesClaro } from 'src/app/models/finalidades.model';
import { FinalidadeRequest } from 'src/app/models/pedido/request/finalidade-request';
import { Pedidos } from 'src/app/models/pedidos.model';
import { MSolicitarRelAnaliticoService } from './solicitar-rel-analitico.service';

enum AlertType { SUCCESS, ERROR, MISSING_FIELD, INVALID_DATE_RANGE }

@Component({
  selector: 'app-m-solicitar-relatorio-analitic',
  templateUrl: './m-solicitar-relatorio-analitic.component.html',
  styleUrls: ['./m-solicitar-relatorio-analitic.component.scss']
})

export class MSolicitarRelatorioAnaliticComponent implements OnInit {

  @ViewChild("modalRelAnalitico") modalRelAnalitico: any;
  @ViewChild("modalRelAnaliticoEmAndamento") modalRelAnaliticoEmAndamento: ElementRef;

  closeResult: string;
  modalOptions: NgbModalOptions;

  form: FormGroup;
  protocolo: number;
  status: string = '';
  datacriacaoprotocolo: Date = new Date();
  dataInicio: Date;
  dataFim: Date;
  nuPedido: number;
  pedido: Pedidos;
  isAbleToRequestNewRelAnalitico: boolean;
  submmited: boolean;
  hasSelectedSection: boolean;

  finalidade: FinalidadeRequest;
  finalidadesList: FinalidadeRequest[];

  atributomarketingList: any[];
  motivomarketingList: string[];

  atributocreditoList: any[];
  motivocreditoList: string[];

  atributoprevfraudeList: any[];
  motivoprevfraudeList: string[];

  atributodataqualityList: any[];
  motivodataqualityList: string[];

  atributoCertificadoList: any[];
  motivoCertificadoList: string[];

  atributoScrList: any[];
  motivoScrList: string[];

  menssagemErro: string = '';
  menssagemAtencao: string = '';

  successAlertActive: boolean = false;
  errorAlertActive: boolean = false;
  missingFieldsAlertActive: boolean = false;
  missingFieldsAlertActiveDate: boolean = false;

  dataQuality = "DATA QUALITY";

  constructor(
    private service: MSolicitarRelAnaliticoService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {

    this.dataInicio = new Date();
    this.dataFim = new Date();

    this.isAbleToRequestNewRelAnalitico = this.data ? this.data.isAbleToRequestNewRelAnalitico : false;

    this.initData(this.data);
    this.initForm();
    this.initFields();
    this.listarFinalidades();
  }

  private initData(dados: any) {

    this.datacriacaoprotocolo = dados?.data ? dados.data.datacriacaoprotocolo : null;
    this.protocolo = dados?.data ? dados.data.protocolo : null;
    this.status = dados?.data ? dados.data.status : null;
    this.dataInicio = dados?.data ? dados.data.dataInicio : null;
    this.dataFim = dados?.data ? dados.data.dataFim : null;
  }

  private initForm() {
    this.form = this.fb.group({
      chkFinalidadeMarketing: [false, [Validators.requiredTrue]],
      chkAtributoMarketing: new FormArray([]),
      hiddenAtributoMarketing: new FormControl('', Validators.required),
      motivoMarketing: ['', [Validators.required]],

      chkFinalidadeCredito: [false, [Validators.requiredTrue]],
      chkAtributoCredito: new FormArray([]),
      hiddenAtributoCredito: new FormControl('', Validators.required),
      motivoCredito: ['', [Validators.required]],

      chkFinalidadeDataQuality: [false, [Validators.requiredTrue]],
      chkAtributoDataQuality: new FormArray([]),
      hiddenAtributoDataQuality: new FormControl('', Validators.required),
      motivoDataQuality: ['', [Validators.required]],

      chkFinalidadePrevFraude: [false, [Validators.requiredTrue]],
      chkAtributoPrevFraude: new FormArray([]),
      hiddenAtributoPrevFraude: new FormControl('', Validators.required),
      motivoPrevFraude: ['', [Validators.required]],

      chkFinalidadeCertificado: [false, [Validators.requiredTrue]],
      chkAtributoCertificado: new FormArray([]),
      hiddenAtributoCertificado: new FormControl('', Validators.required),
      motivoCertificado: ['', [Validators.required]],

      chkFinalidadeScr: [false, [Validators.requiredTrue]],
      chkAtributoScr: new FormArray([]),
      hiddenAtributoScr: new FormControl('', Validators.required),
      motivoScr: ['', [Validators.required]],

      dataInicio: ['', [Validators.required]],
      dataFim: ['', [Validators.required]]
    });
  }

  private initFields() {
    this.protocolo = 0;
    this.pedido = new Pedidos();

    this.finalidade = new FinalidadeRequest();
    this.successAlertActive = false;
    this.errorAlertActive = false;
    this.missingFieldsAlertActive = false;
    this.missingFieldsAlertActiveDate = false;
    this.isAbleToRequestNewRelAnalitico = true;
    this.submmited = false;
    this.hasSelectedSection = false;

    this.motivomarketingList = [];
    this.atributomarketingList = [];
    this.motivocreditoList = [];
    this.atributocreditoList = [];
    this.motivoprevfraudeList = [];

    this.atributoprevfraudeList = [];
    this.motivodataqualityList = [];
    this.atributodataqualityList = [];

    this.motivoCertificadoList = [];
    this.atributoCertificadoList = [];

    this.motivoScrList = [];
    this.atributoScrList = [];
  }

  public close() {
    this.modalService.dismissAll();
  }

  public updateHasSelectedSection() {
    this.hasSelectedSection =
      this.form.controls.chkFinalidadeCredito.value ||
      this.form.controls.chkFinalidadeDataQuality.value ||
      this.form.controls.chkFinalidadePrevFraude.value ||
      this.form.controls.chkFinalidadeMarketing.value ||
      this.form.controls.chkFinalidadeCertificado.value ||
      this.form.controls.chkFinalidadeScr.value;
  }

  public listarFinalidades() {
    this.service.retrieveFinalidades().subscribe(
      (res) => {
        this.finalidadesList = res;
        this.extrairMotivos();
        this.extrairAtributos();
        this.carregarDadosTela();
      }, err => {
        this.menssagemErro = err.message.toString();
        this.showAlertMessage(AlertType.ERROR);
      });
  }

  private processaMotivos(finalidade, reason): void {

    switch (finalidade.description.toLocaleUpperCase()) {
      case 'MARKETING': {
        if (!this.motivomarketingList.includes(reason)) {
          this.motivomarketingList.push(reason);
        }
        break;
      }

      case 'CREDITO': {
        if (!this.motivocreditoList.includes(reason)) {
          this.motivocreditoList.push(reason);
        }
        break;
      }

      case 'FRAUDE': {
        if (!this.motivoprevfraudeList.includes(reason)) {
          this.motivoprevfraudeList.push(reason);
        }
        break;
      }

      case this.dataQuality: {
        if (!this.motivodataqualityList.includes(reason)) {
          this.motivodataqualityList.push(reason);
        }
        break;
      }

      case 'CERTIFICADO_DIGITAL': {
        if (!this.motivoCertificadoList.includes(reason)) {
          this.motivoCertificadoList.push(reason);
        }
        break;
      }

      case 'SCR': {
        if (!this.motivoScrList.includes(reason)) {
          this.motivoScrList.push(reason);
        }
        break;
      }

      default: {
        console.log('não foram encontrados motivos a serem carregados');
      }
    }
  }

  public extrairMotivos(): void {

    this.finalidadesList.forEach(finalidade => {
      if (finalidade.reasons != null) {
        finalidade.reasons.forEach(reason => {
          this.processaMotivos(finalidade, reason)
        })
      }
    });
  }

  private processaAtributos(finalidade, columnAttributes): void {

    switch (finalidade.description.toLocaleUpperCase()) {
      case 'MARKETING': {
        if (!this.atributomarketingList.includes(columnAttributes.id)) {
          this.atributomarketingList.push(columnAttributes);
        }
        break;
      }

      case 'CREDITO': {
        if (!this.atributocreditoList.includes(columnAttributes.id)) {
          this.atributocreditoList.push(columnAttributes);
        }
        break;
      }

      case 'FRAUDE': {
        if (!this.atributoprevfraudeList.includes(columnAttributes.id)) {
          this.atributoprevfraudeList.push(columnAttributes);
        }
        break;
      }

      case this.dataQuality: {
        if (!this.atributodataqualityList.includes(columnAttributes.id)) {
          this.atributodataqualityList.push(columnAttributes);
        }
        break;
      }

      case 'CERTIFICADO_DIGITAL': {
        if (!this.atributoCertificadoList.includes(columnAttributes.id)) {
          this.atributoCertificadoList.push(columnAttributes);
        }
        break;
      }

      case 'SCR': {
        if (!this.atributoScrList.includes(columnAttributes.id)) {
          this.atributoScrList.push(columnAttributes);
        }
        break;
      }

      default: {
        console.log('não foram encontrados atributos a serem carregados');
      }
    }
  }

  private extrairAtributos(): void {

    this.finalidadesList.forEach(finalidade => {
      if (finalidade.columnAttributes != null) {
        finalidade.columnAttributes.forEach(columnAttributes => {
          this.processaAtributos(finalidade, columnAttributes)
        })
      }
    });
  }

  public carregarDadosTela(): void {
    this.loadAtributos();
    this.addEventsOnAtributos();
    this.addEventsOnFinalidades();
  }

  private loadAtributos() {
    this.atributomarketingList.forEach((o, i) => {
      (this.form.get('chkAtributoMarketing') as FormArray).push(new FormControl(false));
    });
    this.atributocreditoList.forEach((o, i) => {
      (this.form.get('chkAtributoCredito') as FormArray).push(new FormControl(false));
    });
    this.atributodataqualityList.forEach((o, i) => {
      (this.form.get('chkAtributoDataQuality') as FormArray).push(new FormControl(false));
    });
    this.atributoprevfraudeList.forEach((o, i) => {
      (this.form.get('chkAtributoPrevFraude') as FormArray).push(new FormControl(false));
    });
    this.atributoCertificadoList.forEach((o, i) => {
      (this.form.get('chkAtributoCertificado') as FormArray).push(
        new FormControl(false)
      );
    });
    this.atributoScrList.forEach((o, i) => {
      (this.form.get('chkAtributoScr') as FormArray).push(
        new FormControl(false)
      );
    });
  }

  private addEventsOnAtributos() {
    (this.form.get('chkAtributoMarketing') as FormArray).valueChanges.subscribe((v) => {
      this.form.controls.hiddenAtributoMarketing.setValue(this.mapItems(v));
    });
    (this.form.get('chkAtributoCredito') as FormArray).valueChanges.subscribe((v) => {
      this.form.controls.hiddenAtributoCredito.setValue(this.mapItems(v));
    });
    (this.form.get('chkAtributoDataQuality') as FormArray).valueChanges.subscribe((v) => {
      this.form.controls.hiddenAtributoDataQuality.setValue(this.mapItems(v));
    });
    (this.form.get('chkAtributoPrevFraude') as FormArray).valueChanges.subscribe((v) => {
      this.form.controls.hiddenAtributoPrevFraude.setValue(this.mapItems(v));
    });
    (this.form.get('chkAtributoCertificado') as FormArray).valueChanges.subscribe((v) => {
      this.form.controls.hiddenAtributoCertificado.setValue(this.mapItems(v));
    });
    (this.form.get('chkAtributoScr') as FormArray).valueChanges.subscribe((v) => {
      this.form.controls.hiddenAtributoScr.setValue(this.mapItems(v));
    });
  }

  private addEventsOnFinalidades() {
    this.form.get('chkFinalidadeMarketing').valueChanges.subscribe((v) => {
      this.updateHasSelectedSection();
    });
    this.form.get('chkFinalidadeCredito').valueChanges.subscribe((v) => {
      this.updateHasSelectedSection();
    });
    this.form.get('chkFinalidadeDataQuality').valueChanges.subscribe((v) => {
      this.updateHasSelectedSection();
    });
    this.form.get('chkFinalidadePrevFraude').valueChanges.subscribe((v) => {
      this.updateHasSelectedSection();
    });
    this.form.get('chkFinalidadeCertificado').valueChanges.subscribe((v) => {
      this.updateHasSelectedSection();
    });
    this.form.get('chkFinalidadeScr').valueChanges.subscribe((v) => {
      this.updateHasSelectedSection();
    });
  }

  private mapItems(items) {
    const selectedItems = items.filter((item) => item);
    return selectedItems.length ? selectedItems : null;
  }

  public resetAttributes(e, nameDropList: string) {
    switch (nameDropList) {
      case 'drpMotivoMarketing': {
        this.form.get('chkAtributoMarketing')['controls']
          .forEach((v, i, a) => a[i].value = false);
        this.form.controls.hiddenAtributoMarketing.setValue('');
        break;
      }
      case 'drpMotivoCredito': {
        this.form.get('chkAtributoCredito')['controls']
          .forEach((v, i, a) => a[i].value = false);
        this.form.controls.hiddenAtributoCredito.setValue('');
        break;
      }
      case 'drpMotivoPrevFraude': {
        this.form.get('chkAtributoPrevFraude')['controls']
          .forEach((v, i, a) => a[i].value = false);
        this.form.controls.hiddenAtributoPrevFraude.setValue('');
        break;
      }
      case 'drpMotivoDataQuality': {
        this.form.get('chkAtributoDataQuality')['controls']
          .forEach((v, i, a) => a[i].value = false);
        this.form.controls.hiddenAtributoDataQuality.setValue('');
        break;
      }
      case 'drpMotivoCertificado': {
        this.form
          .get('chkAtributoCertificado')
          ['controls'].forEach((v, i, a) => (a[i].value = false));
        this.form.controls.hiddenAtributoCertificado.setValue('');
        break;
      }

      case 'drpMotivoScr': {
        this.form
          .get('chkAtributoScr')
          ['controls'].forEach((v, i, a) => (a[i].value = false));
        this.form.controls.hiddenAtributoScr.setValue('');
        break;
      }

      default: { }
    }
  }

  public changeDropList(e, NameDropList: string) {

    switch (NameDropList) {
      case 'drpMotivoMarketing': {
        this.form.controls.motivoMarketing.setValue(e.value.toString())

        if (e.value.length <= 0) {
          this.form.get('chkAtributoMarketing')['controls'].forEach((v, i, a) => a[i].value = false);
        }
        break;
      }
      case 'drpMotivoCredito': {
        this.form.controls.motivoCredito.setValue(e.value.toString())

        if (e.value.length <= 0) {
          this.form.get('chkAtributoCredito')['controls'].forEach((v, i, a) => a[i].value = false);
        }
        break;
      }
      case 'drpMotivoPrevFraude': {
        this.form.controls.motivoPrevFraude.setValue(e.value.toString())

        if (e.value.length <= 0) {
          this.form.get('chkAtributoPrevFraude')['controls'].forEach((v, i, a) => a[i].value = false);
        }
        break;
      }
      case 'drpMotivoDataQuality': {
        this.form.controls.motivoDataQuality.setValue(e.value.toString())

        if (e.value.length <= 0) {
          this.form.get('chkAtributoDataQuality')['controls'].forEach((v, i, a) => a[i].value = false);
        }
        break;
      }
      case 'drpMotivoCertificado': {
        this.form.controls.motivoCertificado.setValue(e.value.toString());

        if (e.value.length <= 0) {
          this.form
            .get('chkAtributoCertificado')
            ['controls'].forEach((v, i, a) => (a[i].value = false));
        }
        break;
      }

      case 'drpMotivoScr': {
        this.form.controls.motivoScr.setValue(e.value.toString());

        if (e.value.length <= 0) {
          this.form
            .get('chkAtributoScr')
            ['controls'].forEach((v, i, a) => (a[i].value = false));
        }
        break;
      }

      default: { }
    }
  }

  public organizaPedido(descricao: string, razoes: any) {
    const finalidade = new Finalidades();
    finalidade.description = descricao;
    finalidade.reasons.push(razoes);
    let atributosSelecionados

    switch (descricao) {
      case 'MARKETING':
        atributosSelecionados = this.getSelectedAtributos(
          this.form.value['chkAtributoMarketing'], this.atributomarketingList);
        break;

      case 'CREDITO':
        atributosSelecionados = this.getSelectedAtributos(
          this.form.value['chkAtributoCredito'], this.atributocreditoList);
        break;

      case this.dataQuality:
        atributosSelecionados = this.getSelectedAtributos(
          this.form.value['chkAtributoDataQuality'], this.atributodataqualityList);
        break;

      case 'FRAUDE':
        atributosSelecionados = this.getSelectedAtributos(
          this.form.value['chkAtributoPrevFraude'], this.atributoprevfraudeList);
        break;

      case 'CERTIFICADO_DIGITAL':
        atributosSelecionados = this.getSelectedAtributos(
          this.form.value['chkAtributoCertificado'], this.atributoCertificadoList);
        break;

      case 'SCR':
        atributosSelecionados = this.getSelectedAtributos(
          this.form.value['chkAtributoScr'], this.atributoScrList);
        break;

      default:
        break;
    }

    finalidade.columnAttributes.push(...atributosSelecionados);
    this.pedido.purposes.push(finalidade);
  }

  public createPedido(): void {

    this.datacriacaoprotocolo = new Date();
    this.protocolo = 0;
    this.service.retrieveProtocolo().subscribe(
      (res) => {
        this.protocolo = res.numeroProtocolo;

        this.pedido = new Pedidos();
        this.pedido.protocol = this.protocolo.toString();
        this.pedido.dtStart = this.ObterData(this.form.get('dataInicio').value);
        this.pedido.dtEnd = this.ObterData(this.form.get('dataFim').value);
        this.pedido.purposes = new Array<Finalidades>();

        if (this.form.controls.chkFinalidadeMarketing.value) {

          this.organizaPedido(DescriptionTypes.MARKETING.toString(), this.form.value.motivoMarketing.trim())

        }
        if (this.form.controls.chkFinalidadeCredito.value) {
          this.organizaPedido(DescriptionTypes.CREDITO.toString(), this.form.value.motivoCredito)

        }
        if (this.form.controls.chkFinalidadeDataQuality.value) {
          this.organizaPedido(DescriptionTypes.DATA_QUALITY.toString().replace("_", " "), this.form.value.motivoDataQuality)

        }
        if (this.form.controls.chkFinalidadePrevFraude.value) {
          this.organizaPedido(DescriptionTypes.FRAUDE.toString(), this.form.value.motivoPrevFraude)
        }
        if (this.form.controls.chkFinalidadeCertificado.value) {
          this.organizaPedido(DescriptionTypes.CERTIFICADO_DIGITAL.toString(), this.form.value.motivoCertificado);
        }
        if (this.form.controls.chkFinalidadeScr.value) {
          this.organizaPedido(DescriptionTypes.SCR.toString(), this.form.value.motivoScr);
        }

        if (this.validateMandatoryFields()) {
          this.service.createPedido(this.pedido).subscribe(
            (res) => {
              this.nuPedido = this.protocolo;
              this.showAlertMessage(AlertType.SUCCESS)
              this.submmited = true;
            },
            (err) => {
              this.showAlertMessage(AlertType.ERROR)
              console.log(err)
            });
        }
      }, err => {
        this.menssagemErro = err.message.toString();
        this.showAlertMessage(AlertType.ERROR)
      });
  }

  private validateMandatoryFields(): boolean {
    let isValid = (this.pedido.purposes.length > 0 || this.pedido.purposeClaro.attributes.length > 0)
      && this.form.controls.dataFim.valid && this.form.controls.dataInicio.valid;

    this.pedido.purposes.forEach(purpose => {
      if (this.isNullOrEmpty(purpose.description) || purpose.columnAttributes.length <= 0) {
        isValid = false;
      }
    });

    if (!isValid) {
      this.showAlertMessage(AlertType.MISSING_FIELD);
    } else if (!this.validateDateRange()) {
      this.showAlertMessage(AlertType.INVALID_DATE_RANGE);
      isValid = false;
    }

    return isValid;
  }

  private validateDateRange() {
    const dataFim: any = new Date(this.ObterData(this.form.value.dataFim));
    const dataInicio: any = new Date(this.ObterData(this.form.value.dataInicio));
    return ((this.calcDateDiff(dataInicio, dataFim) / 365.25) <= 15) &&
      (dataInicio <= dataFim) && (dataFim <= new Date());
  }

  private ObterData(data: string): Date {
    const partes = data.split('/');
    return new Date(Number(partes[2]), Number(partes[1]) - 1, Number(partes[0]));
  }

  calcDateDiff(date2, date1) {
    const diffDays: any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));

    return Math.abs(Math.round(diffDays));
  }

  private showAlertMessage(type: AlertType) {
    this.successAlertActive = false;
    this.errorAlertActive = false;
    this.missingFieldsAlertActive = false;
    this.missingFieldsAlertActiveDate = false;

    switch (type) {
      case AlertType.SUCCESS: { this.successAlertActive = true; break }
      case AlertType.ERROR: { this.errorAlertActive = true; break }
      case AlertType.MISSING_FIELD: { this.missingFieldsAlertActive = true; break }
      case AlertType.INVALID_DATE_RANGE: { this.missingFieldsAlertActiveDate = true; break }
    }
  }

  private getSelectedAtributos(checkboxes, attributesList) {
    return checkboxes
      .map((v, i) => (v ? attributesList[i] : null))
      .filter(v => v !== null);
  }

  private isNullOrEmpty(value) {
    return value == null || value === '';
  }
}
